import { IExercise, IExercisesTableData } from '../../pages/AdminPanel';

export function updateExerciseDisabledState(
 exerciseIndex: number,
 sistolicValue: string | number,
 setExercisesDataState: React.Dispatch<React.SetStateAction<any>>,
 initialExercisesData?: IExercisesTableData[]
) {
 const sistolic =
  typeof sistolicValue === 'string'
   ? parseInt(sistolicValue, 10)
   : sistolicValue;
 const shouldDisable = sistolic >= 140;

 const exercisesToDisable = ['wingsStatic', 'wingsDynamic', 'butterfly', 'bat'];

 setExercisesDataState((prev: any) => {
  const newData = structuredClone(prev);

  exercisesToDisable.forEach((exerciseKey) => {
   if (
    newData[exerciseIndex] &&
    newData[exerciseIndex][exerciseKey as keyof IExercisesTableData]
   ) {
    const exerciseObject = newData[exerciseIndex][
     exerciseKey as any
    ] as IExercise;
    if (exerciseObject && typeof exerciseObject === 'object') {
     const initialExercise =
      initialExercisesData?.[exerciseIndex]?.[
       exerciseKey as keyof IExercisesTableData
      ];
     const initialDisabledState =
      initialExercise &&
      typeof initialExercise === 'object' &&
      'disabled' in initialExercise
       ? (initialExercise as IExercise).disabled
       : false;

     if (shouldDisable) {
      exerciseObject.disabled = true;
     } else {
      exerciseObject.disabled = initialDisabledState;
     }
    }
   }
  });

  return newData;
 });
}
